var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightBottomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8939 8.34302L9.43152 13.1351V15.9331L18 10.4213L16.8939 8.34302Z",
    fill: "#E6D0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4213L8.57158 15.9332V13.1352L1.11234 8.33374L0 10.4213Z",
    fill: "#E6D0B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00157 2.99951L1.7511 7.66075L9.00157 12.3251L16.2583 7.66387L9.00157 2.99951ZM9.00157 5.87228L5.39347 8.19356L4.48989 7.61402L9.00469 4.71009L13.5195 7.61402L12.6159 8.19356L9.00781 5.87228H9.00157Z",
    fill: "#E6D0B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12.9337,
    fill: "white",
    transform: "translate(0 2.99951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBottomIcon);
export default __webpack_public_path__ + "static/media/right_bottom_icon.c4ba098835919d7a0043b93aec3243b7.svg";
export { ForwardRef as ReactComponent };